import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteConfig } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl font-bold text-white mb-4">{siteConfig.name}</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteConfig.description}
            </p>
            <div className="flex items-center space-x-3 mt-4">
              <a href={siteConfig.social.weibo} target="_blank" rel="nofollow noopener" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h5 className="font-medium text-white mb-4">内容分类</h5>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="font-medium text-white mb-4">快速链接</h5>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link></li>
              <li><Link to="/category/movie-news" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">电影资讯</Link></li>
              <li><Link to="/category/series-recommend" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">剧集推荐</Link></li>
              <li><Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">动漫动画</Link></li>
            </ul>
          </div>

          <div>
            <h5 className="font-medium text-white mb-4">联系我们</h5>
            <ul className="space-y-2.5">
              <li className="flex items-start text-sm text-foreground-400">
                <i className="ri-mail-line mr-2 mt-0.5"></i>
                <span>{siteConfig.email}</span>
              </li>
              <li className="flex items-start text-sm text-foreground-400">
                <i className="ri-phone-line mr-2 mt-0.5"></i>
                <span>{siteConfig.phone}</span>
              </li>
              <li className="flex items-start text-sm text-foreground-400">
                <i className="ri-map-pin-line mr-2 mt-0.5"></i>
                <span>{siteConfig.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有
          </p>
          <div className="flex items-center space-x-6 mt-3 sm:mt-0">
            <a href="#" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap">服务条款</a>
            <a href="#" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}